import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PlanService } from './plan.service';
import { IPurposeMissionBeliefs } from './IPurposeMissionBeliefs';


@Injectable()
export class PurposeMissionBeliefsResolve implements Resolve<IPurposeMissionBeliefs> {
  constructor(private planService: PlanService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IPurposeMissionBeliefs> {
    const strategyId = Number.parseInt(route.paramMap.get('strategyId'), 10);
    return this.planService.getPurposeMissionBeliefs(strategyId);
  }
}
